import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateVehicleTypesActions as PaginateActions } from 'store/ducks/vehicleTypes';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import {
  TypesList,
  TypeFilters,
  FindVehicleTypes,
} from 'components/Pages/VehicleTypes';
import { Paginator, ListingPageHeader, SettingsMenu } from 'components/Shared';
import * as S from './styles';

export const VehicleTypesListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('vehicleTypes');

  const {
    data: types,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateVehicleTypes);

  const [query, setQuery] = useState<FindVehicleTypes>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.TruckIcon />}
          title="Tipos de veículos"
          isLoading={loading}
          actions={
            <S.LinkButton
              to={'/configuracoes/tipos-veiculos/criar'}
              size="small"
            >
              <S.PlusIcon /> Novo tipo de veículo
            </S.LinkButton>
          }
        />
        <TypeFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <TypesList
          vehicleTypes={types}
          currentSort={query}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
